import React from "react";
import styles from "./TypeLabel.module.scss";

export type Type =
  | "system"
  | "regular"
  | "recurring"
  | "signUp"
  | "confirmation"
  | "promoCode"
  | "loyalty"
  | "cashback"
  | "reload";

type Props = {
  type: Type;
};

const typeClassMap: Record<Type, string> = {
  system: styles["type-label--system"],
  regular: styles["type-label--regular"],
  recurring: styles["type-label--recurring"],
  signUp: styles["type-label--signUp"],
  confirmation: styles["type-label--confirmation"],
  promoCode: styles["type-label--promocode"],
  loyalty: styles["type-label--loyalty"],
  cashback: styles["type-label--cashback"],
  reload: styles["type-label--reload"],
};

export const TypeLabel: React.FC<Props> = ({ type }) => {
  return (
    <div className={`${styles["type-label"]} ${typeClassMap[type]}`}>
      {type}
    </div>
  );
};
